var _ShapeSizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { InlineChildren } from '@doordash/design-language';
export var MINIMUM_CLICKABLE_HEIGHT = 36;
export var Sizes = {
  Large: 'Large',
  Medium: 'Medium',
  Small: 'Small'
};
export var DashSizes = {
  Large: {
    height: 8,
    width: 32,
    spacing: InlineChildren.Sizes.XSmall
  },
  Medium: {
    height: 6,
    width: 24,
    spacing: InlineChildren.Sizes.XxSmall
  },
  Small: {
    height: 4,
    width: 16,
    spacing: InlineChildren.Sizes.XxSmall
  }
};
export var DotSizes = {
  Large: {
    height: 10,
    width: 10,
    spacing: InlineChildren.Sizes.XxSmall
  },
  Medium: {
    height: 8,
    width: 8,
    spacing: InlineChildren.Sizes.XxSmall
  },
  Small: {
    height: 6,
    width: 6,
    spacing: InlineChildren.Sizes.XxxSmall
  }
};
export var Shapes = {
  Dash: 'Dash',
  Dot: 'Dot'
};
export var ShapeSizes = (_ShapeSizes = {}, _defineProperty(_ShapeSizes, Shapes.Dash, DashSizes), _defineProperty(_ShapeSizes, Shapes.Dot, DotSizes), _ShapeSizes);